(function($) {

    siteHeader = $('#siteHeader');
    siteMain = $('#siteMain');
    siteHeaderHeight = siteHeader.outerHeight();

    // Toggle collapse on submenu
    $('#navbarToggle').on('click', function() {
        var primaryNavigation = $('#primaryNavigation');
        $this = $(this);

        // Dropdown toggle setup
        if(primaryNavigation.hasClass('is-expanded')) {
            primaryNavigation.removeClass('is-expanded');
            $('body').removeClass('no-scroll');
            $this.addClass('collapsed');
            $this.attr('aria-expanded', 'false');

        } else {
            primaryNavigation.addClass('is-expanded');
            $('body').addClass('no-scroll');
            $this.removeClass('collapsed');
            $this.attr('aria-expanded', 'true');
        }

        // dropdown menu
        $('#primaryNavigation .dropdown-toggle')
            .removeClass('show')
            .attr('aria-expanded', 'false');
        $('#primaryNavigation .dropdown-menu')
            .removeClass('show')

    });


    // dropdown back button
    $('#primaryNavigation .dropdown-back .btn').on('click', function() {
        $('#primaryNavigation .dropdown-toggle')
            .removeClass('show')
            .attr('aria-expanded', 'false');
        $('#primaryNavigation .dropdown-menu')
            .removeClass('show')
    });


    // animate unlerline graphic for current menu item
    setTimeout(function() {
        $('#primaryNavigation')
            .find('.is-current')
            .addClass('is-animated');
    }, 1000);


    // dropdown on hover
    if ($(window).width() >= 992) {
        $('#primaryNavigation .dropdown-toggle').on('mouseover', function() {
            $(this)
                .addClass('show')
                .attr('aria-expanded', 'true')
                .closest('.dropdown')
                .find('.dropdown-menu')
                .addClass('show')
        });
        $('#primaryNavigation .nav-item').on('mouseleave', function() {
            $('#primaryNavigation .dropdown-toggle')
                .removeClass('show')
                .attr('aria-expanded', 'false');
            $('#primaryNavigation .dropdown-menu')
                .removeClass('show')
        });
    } else {
        $('#primaryNavigation .dropdown-toggle').on('click', function(e) {
            e.preventDefault();
            $this = $(this);

            $this
                .addClass('show')
                .attr('aria-expanded', 'true')
                .closest('.dropdown')
                .find('.dropdown-menu')
                .addClass('show')
        });
    }


    // toggle search bar
    $('#navbarSearchToggle').on('click', function() {
        $this = $(this);
        var navSearch = $('#navbarSearch');
        var navPrimary = $('.navbar-primary .nav-link')

        /*Toggle active classes*/
        if($this.hasClass('is-active')) {
            $this.removeClass('is-active');
            navSearch.removeClass('is-active');
            navPrimary.removeClass('is-hidden');

        } else {
            $this.addClass('is-active');
            navSearch.addClass('is-active');
            navPrimary.addClass('is-hidden');

            setTimeout(function() {
                $('#navbarSearch .form-control').focus()
            }, 300);
        }
    });

}(jQuery));
